<template>
    <!--div-->
        <!--  BEGIN NAVBAR  -->
        <Header></Header>
        <!--  END NAVBAR  -->

        <!--  BEGIN MAIN CONTAINER  -->
        <div
            class="main-container"
            id="container"
            :class="[!$store.state.is_show_sidebar ? 'sidebar-closed sbar-open' : '', $store.state.menu_style === 'collapsible-vertical' ? 'collapsible-vertical-mobile' : '']"
        >
            <!--  BEGIN OVERLAY  -->
            <div class="overlay" :class="{ show: !$store.state.is_show_sidebar }" @click="$store.commit('toggleSideBar', !$store.state.is_show_sidebar)"></div>
            <div class="search-overlay" :class="{ show: $store.state.is_show_search }" @click="$store.commit('toggleSearch', !$store.state.is_show_search)"></div>
            <!-- END OVERLAY -->

            <!--  BEGIN SIDEBAR  -->
            <Sidebar></Sidebar>
            <!--  END SIDEBAR  -->

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content">
                <div class="row layout-top-spacing mx-2"  v-if="msg">
                <div class="col-12">
                    <div class="alert alert-arrow-left alert-light-warning alert-icon-left mb-0 text-break">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-bell"
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                        <div :class="messageclass">{{msg}}</div>
                        
                        
                    </div>
                </div>
            </div>
                <router-view />

                <!-- BEGIN FOOTER if is_max_table is set, then do NOT draw it -->
                <!-- <Footer v-if = '!$store.state.is_max_table'></Footer> -->
                <!-- END FOOTER -->
            </div>
            <!--  END CONTENT AREA  -->

            <!-- BEGIN APP SETTING LAUNCHER -->
<!--
            <app-settings />
-->
            <!-- END APP SETTING LAUNCHER -->
        </div>
    <!--/div-->
</template>

<script setup>
    import Header from '@/components/layout/header.vue';
    import Sidebar from '@/components/layout/sidebar.vue';
    import Footer from '@/components/layout/footer.vue';
    //import appSettings from '@/components/app-settings.vue';

    import { useRoute } from "vue-router"
    import { ref, watch } from 'vue';

    const msg = ref(null)
    const route = useRoute()
    
    // Handle error messages

    watch(route, (to) => {
        if (to.query.err) {
            if (to.query.err == "projnotfound")
            {
                msg.value = "Project from query string or local storage not valid! Select another please!"
            }
        }
        else {
            msg.value = null
        }
    })


</script>
